import React, { Fragment, useMemo } from "react"
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer"
import moment from "moment"
import crewMamaLogo from "../../../../../assets/images/crewmama_brand.png"
import gttLogo from "../../../../../assets/images/gtt.png"
import adeskLogo from "../../../../../assets/images/adesk.jpg"
import mcsLogo from "../../../../../assets/images/mcs_logo.jpg"
import { cleanPhoneNumber } from "../../../../../utils/cleanPhoneNumber"
import parseClientCompanyAddress from "../../../../../utils/parseClientCompanyAddress"
import fixCompanyAddress from "../../../../../utils/fixCompanyAddress"

const logos = {
  crewmamaLogo: crewMamaLogo,
  gttLogo: gttLogo,
  adeskLogo: adeskLogo,
  mcsLogo: mcsLogo,
}

const styles = StyleSheet.create({
  headingSection: {
    marginBottom: 10,
    padding: 10,
  },
  logo: {
    maxWidth: 150,
    maxHeight: 50,
    alignSelf: "flex-end",
    objectFit: "fill",
  },
  headingCol: {
    width: "50%",
  },
  actionsSection: {
    marginBottom: 10,
    marginTop: 10,
    border: "1px solid #9A9A9A",
    borderRadius: "4px",
    padding: 10,
    minHeight: 100,
    width: 200,
  },
  headingTitle: {
    textTransform: "uppercase",
    color: "#00003D",
    opacity: "0.4",
    fontWeight: 800,
    fontSize: "11px",
  },
  boldText: {
    fontWeight: 800,
  },
  boldTextWithMarginTop: {
    fontWeight: 800,
    marginTop: "20px",
  },
  adBilling: {
    marginTop: "10px",
    marginRight: "10px",
  },
})

const PdfHeader = ({ data = {}, type = "" }) => {

  // Client info render
  const clientAddress =
    data &&
    data.client_company_location &&
    parseClientCompanyAddress(data.client_company_location)
  const clientPhone =
    (data && data.client_phone && cleanPhoneNumber(data.client_phone)) || ""

  // Organization info render
  const companyFrom = (data && data.company_name) || ""
  const companyPhone =
    (data && data.company_phone && cleanPhoneNumber(data.company_phone)) || ""

  const organizationLogo = useMemo(
    () => {
      if (data && data.company_id !== 2) {
        return (
          data &&
          data.company_logo_image &&
          JSON.parse(data.company_logo_image).url
        )
      } else {
        if (data && data.crewmama_or_gtt) {
          return logos[`${data.crewmama_or_gtt}Logo`]
        } else {
          return null
        }
      }
    },
    [data]
  )

  console.log("organizationLogo", organizationLogo)

  const documentDate = useMemo(
    () => {
      if (data) {
        if (data[`${type.toLowerCase()}_shoot_date`]) {
          return moment(data[`${type.toLowerCase()}_shoot_date`]).format(
            "M/D/YYYY"
          )
        } else if (data.start_date) {
          return moment(data.start_date).format("M/D/YYYY")
        }
      } else {
        return ""
      }
    },
    [data]
  )
  return (
    <Fragment>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <View>
          <Text style={styles.headingTitle}>
            {type === "estimate" ? "Estimate:" : "Invoice:"}
            <Text style={{ color: "#000000", opacity: 1, fontSize: "10px" }}>
              {(data && data[`${type}_id`]) || data.shoot_id || data.id}
            </Text>
          </Text>
          {documentDate !== "" && (
            <Text style={styles.headingTitle}>
              {!data[`${type.toLowerCase()}_shoot_date`]
                ? "Invoice Date: "
                : type + " Date: "}
              <Text style={{ color: "#000000", opacity: 1, fontSize: "10px" }}>
                {documentDate}
              </Text>
            </Text>
          )}
        </View>
        {organizationLogo && (
          <Image style={styles.logo} src={organizationLogo} />
        )}
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "15px",
        }}
      >
        <View style={styles.headingCol}>
          <Text style={styles.headingTitle}>{type} For: </Text>
          {data.client_name && (
            <Text style={styles.boldText}>
              Client Name: <Text>{data.client_name}</Text>
            </Text>
          )}
          {(clientPhone || clientPhone !== "") && (
            <Text style={styles.boldText}>
              Client Phone: <Text>{clientPhone}</Text>
            </Text>
          )}

          {data.client_company_name && (
            <Text style={styles.boldText}>
              Client Company: <Text>{data.client_company_name}</Text>
            </Text>
          )}

          {data.client_company_location && (
            <Text style={styles.boldText}>
              Client Address: <Text>{clientAddress[0]}</Text>
            </Text>
          )}
          {data.client_company_location && <Text>{clientAddress[1]}</Text>}
          {data.ad_billing_note && (
            <View style={styles.adBilling}>
              <Text>{data.ad_billing_note}</Text>
            </View>
          )}
        </View>
        <View style={styles.headingCol}>
          <Text style={styles.headingTitle}>{type} From: </Text>
          <Text>{companyFrom}</Text>
          {data.company_address && (
            <Text>
              {
                fixCompanyAddress(
                  data.company_street,
                  data.company_street_number,
                  data.company_zip,
                  data.company_city,
                  data.company_state
                )[0]
              }
            </Text>
          )}
          {data.company_address && (
            <Text>
              {
                fixCompanyAddress(
                  data.company_street,
                  data.company_street_number,
                  data.company_zip,
                  data.company_city,
                  data.company_state
                )[1]
              }
            </Text>
          )}
          <Text>{companyPhone}</Text>
          {data.representative_name && (
            <Text>Rep: {data.representative_name}</Text>
          )}
        </View>
      </View>
    </Fragment>
  )
}

export default PdfHeader
